<template>
  <el-dialog title="Adicionar Arquivo" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="25%">
    <el-form ref="form" :model="arquivo" :rules="validacao" size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-form-item label="Descrição" prop="descricao">
        <el-input v-model="arquivo.descricao"/>
      </el-form-item>

      <el-form-item label="Observações">
        <el-input rows="2" type="textarea" v-model="arquivo.localizacaoFisica"/>
      </el-form-item>

      <el-form-item>
        <el-upload ref="upload" name="arquivo" :action="''" :multiple="false" :limit="1" :auto-upload="false" class="file-upload-box">
          <el-button @click="triggerSelecionarArquivo" type="primary" slot="trigger" style="width: 100%" icon="el-icon-search" round class="btn-box-shadow">Selecionar Arquivo</el-button>
          <div slot="tip">Arquivos com tamanho de até <b>4MB</b></div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="validarUpload()" style="margin-left: 10px;" round class="btn-box-shadow"><i class="el-icon-upload"></i> Upload</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { TAMANHO_MAXIMO_ARQUIVO_EM_BYTES } from '../../util/constantes';
import { mapState, mapActions } from "vuex";
import URLS from "../../util/urls.js";

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },
  data() {
    return {
      validacao: {
        descricao: [
          { type: "string", required: true, whitespace: true, trigger: 'blur' }
        ]
      },
      arquivo: {
        descricao: "",
        localizacaoFisica: ""
      }
    };
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    // ALUGUEL
    ...mapState("alugueisContratosStore", {
      aluguel(state) { return state.aluguelSelecionado; }
    }),
    ...mapState("alugueisImoveisStore", {
      imovelAluguel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("alugueisClientesStore", {
      clienteAluguel(state) { return state.clienteSelecionado; }
    }),

    // VENDA
    ...mapState('vendasClientesStore', {
      cliente(state) { return state.clienteSelecionado; }
    }),
    ...mapState('vendasImoveisStore', {
      imovel(state) { return state.imovelSelecionado; }
    }),
    ...mapState("vendasContratosStore", {
      venda(state) { return state.vendaSelecionada; }
    }),
    url() { return URLS.ARQUIVOS_UPLOAD; }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    // ALUGUEL
    ...mapActions("alugueisContratosStore", ["uploadArquivoAluguel"]),
    ...mapActions("alugueisImoveisStore", {uploadArquivoImovelAluguel: "uploadArquivoImovel"}),
    ...mapActions("alugueisClientesStore", {uploadArquivoClienteAluguel: "uploadArquivoCliente"}),

    // VENDA
    ...mapActions("vendasClientesStore", ["uploadArquivoCliente"]),
    ...mapActions("vendasImoveisStore", ["uploadArquivoImovel"]),
    ...mapActions("vendasContratosStore", ["uploadArquivoVenda"]),
    validarUpload() {
      this.$refs['form'].validate(isValid => {
        const formIsNotValid = !isValid;
        if(formIsNotValid) {
          this.exibirAlert('Preencha todos os campos obrigatórios');
          return;
        }

        const nenhumArquivoFoiSelecionado = this.$refs.upload.uploadFiles.length === 0;
        if(nenhumArquivoFoiSelecionado) {
          this.exibirAlert('Selecione o Arquivo');
          return;
        }

        const arquivo = this.$refs.upload.uploadFiles[0].raw;

        const arquivoExcedeTamanhoLimite = arquivo.size > TAMANHO_MAXIMO_ARQUIVO_EM_BYTES;
        if(arquivoExcedeTamanhoLimite) {
          this.exibirAlert('O tamanho do arquivo excede 4MB');
          return;
        }

        this.uploadArquivo();
      });
    },
    uploadArquivo() {
      let payload = new FormData();

      payload.append("arquivo", this.$refs.upload.uploadFiles[0].raw);
      payload.append("descricao", this.arquivo.descricao);
      payload.append("localizacaoFisica", this.arquivo.localizacaoFisica);
      payload.append("path", this.$refs.upload.uploadFiles[0].name);

      // ALUGUEL
      if(this.tipo == "ALUGUEL") { this.uploadAluguel(payload); }
      if(this.tipo == "IMOVEL_ALUGUEL") { this.uploadImovelAluguel(payload); }
      if(this.tipo == "CLIENTE_ALUGUEL") { this.uploadClienteAluguel(payload); }

      // VENDA
      if(this.tipo == "CLIENTE") { this.uploadCliente(payload); }
      if(this.tipo == "IMOVEL") { this.uploadImovel(payload); }
      if(this.tipo == "VENDA") { this.uploadVenda(payload); }
    },

    // ALUGUEL
    uploadAluguel(payload) {
      payload.append("idAluguel", this.aluguel.id); 

      this.showLoading()
      this.uploadArquivoAluguel(payload)
      .then(resultado => {
        this.hideLoading();

        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },
    uploadImovelAluguel(payload) {
      payload.append("idImovel", this.imovelAluguel.id);

      this.showLoading();
      this.uploadArquivoImovelAluguel(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
    },
    uploadClienteAluguel(payload) {
      payload.append("idCliente", this.clienteAluguel.id);

      this.showLoading();
      this.uploadArquivoClienteAluguel(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
    },

    // VENDA
    uploadCliente(payload) {
      payload.append("idCliente", this.cliente.id);

      this.showLoading();
      this.uploadArquivoCliente(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
    },
    uploadImovel(payload) {
      payload.append("idImovel", this.imovel.id);

      this.showLoading();
      this.uploadArquivoImovel(payload)
          .then(resultado => {
            this.hideLoading();

            switch (resultado.status) {
              case "SUCESSO":
                this.$message.success(resultado.mensagem);
                this.fechar();
                break;
              case "FALHA":
              case "ERRO":
                this.$message.error(resultado.mensagem);
                break;
            }
          })
          .catch(() => {
            this.hideLoading();
            this.$message.error("Ocorreu um erro");
          });
    },
    uploadVenda(payload) {
      payload.append("idVenda", this.venda.id); 

      this.uploadArquivoVenda(payload)
      .then(resultado => {
        this.hideLoading();

        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Ocorreu um erro");
      });
    },

    triggerSelecionarArquivo() {
      const isUmArquivoFoiSelecionado = this.$refs.upload.uploadFiles.length > 0;
      if(isUmArquivoFoiSelecionado) {
        this.limparArquivos();
      }
    },

    limparArquivos() {
      this.$refs.upload.clearFiles();
    },
    
    reset() {
      this.arquivo.descricao = "";
      this.arquivo.localizacaoFisica = "";
      if(this.$refs.upload) { this.$refs.upload.clearFiles(); }

      this.$refs['form'].resetFields();
    },
    fechar() {
      this.reset();
      this.$emit("close");
    },

    exibirAlert(mensagem) {
      this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'warning' });
    },    
  }
};
</script>

<style>
.file-upload-box .el-upload {
  margin-top: 5px;
  display: block !important;
}
</style>